'use client';

import React from 'react';
import { Swiper, SwiperSlide, } from 'swiper/react';
import { Autoplay, Navigation, Scrollbar } from 'swiper/modules';
import  LatestVehicleCard from './LatestVehicleCard';
import 'swiper/css';
import 'swiper/css/pagination';
import  './LatestVehiclesSlider.scss';

export default function LatestVehiclesSlider() {
    return (
      <>
        <div className="l-node-frontpage__latest-vehicles">
            <Swiper
                className="latest-vehicles-slider-home"
                modules={[Autoplay, Navigation, Scrollbar]}
                spaceBetween={0}  // Space between slides
                slidesPerView={1}  // Show 1 slide at a time
                navigation={false}  // Enable navigation buttons
                scrollbar={{ draggable: true }}  // Enable draggable scrollbar
                loop={true}  // Infinite looping
                // autoplay={{ delay: 5000 }}  // Autoplay every 5 seconds
                centeredSlides={true}
                effect="fade"  // Fade transition effect
                speed={500}  // Slide transition speed
                lazyPreloadPrevNext={1}
                breakpoints={{
                767: {
                    slidesPerView: "auto",
                },
                1023: {
                    slidesPerView: "auto",
                },
                }}
            >
                <SwiperSlide>
                    <LatestVehicleCard />
                </SwiperSlide>

                <SwiperSlide>
                    <LatestVehicleCard />
                </SwiperSlide>

                <SwiperSlide>
                    <LatestVehicleCard />
                </SwiperSlide>

                <SwiperSlide>
                    <LatestVehicleCard />
                </SwiperSlide>

                <SwiperSlide>
                    <LatestVehicleCard />
                </SwiperSlide>

                <SwiperSlide>
                    <LatestVehicleCard />
                </SwiperSlide>

                <SwiperSlide>
                    <LatestVehicleCard />
                </SwiperSlide>

                <SwiperSlide>
                    <LatestVehicleCard />
                </SwiperSlide>

            </Swiper>
        </div>
      </>
    );
  }
  